export default __webpack_public_path__ + "static/media/c001-fsi-2.27cb0a0a.jpg";